// extracted by css-extract-rspack-plugin
export default {"badDataChart":"BadData-module__badDataChart___LmYeU"};